import { Fragment, useMemo, useState } from 'react';
import styles from './styles.module.scss';
import { Badge } from 'components-antd';
import Icons from 'pages/FormBuilder/Icons';
import { FormCommentPanel } from 'pages/FormProcess/components';

import { useManageFormComments } from '../../FieldRenderer/FormComments/hooks/useManageFormComments';
import classNames from 'classnames';
import { CommentBadgeIcon } from './CommentBadgeIcon';
import { CommentBadgePanel } from './CommentBadgePanel';

type CommentBadgeWidgetTypes = {
  headerWidget?: boolean;
  fillWhite?: boolean;
};

export const CommentBadgeWidget = ({ headerWidget, fillWhite }: CommentBadgeWidgetTypes) => {
  const [commentPanelOpen, setCommentPanelOpen] = useState(false);

  return (
    <Fragment>
      <div
        className={classNames({ [styles.commentsWidgetContainer]: !headerWidget })}
        onClick={(e) => {
          e.stopPropagation();
          setCommentPanelOpen(true);
        }}
      >
        <CommentBadgeIcon headerWidget={headerWidget} fillWhite={fillWhite} />
      </div>

      <CommentBadgePanel isOpen={commentPanelOpen} setOpen={setCommentPanelOpen} />
    </Fragment>
  );
};
